import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import Footer from "../Home/Footer";
import "./InternationalEventsParticipation.css";
import { useNavigate } from "react-router-dom";
import IntenationEvent1 from "../assets/img/IntenationEvent1.png"

const events = [
  {
    id: 1,
    title: "Ag in Motion 2025",
    date: "July 15th to 17th July 2025",
    location: "Saskatchewan, Canda",
    image: IntenationEvent1,
  },

];

const InternationalEventsParticipation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);



  return (
    <div className="international-events-container">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.4)), url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHcNdViXEx5OYoJP4u7WfOVxVgCZrzFfzW6A&s')",
        }}
      >
        <div className="hero-overlay" data-aos="fade-down">
          <h1 className="hero-title">International Events Participation</h1>
          <p className="hero-subtitle">
            Showcasing expertise and innovation on the global stage.
          </p>
        </div>
      </section>

      {/* Events */}
      <section className="events-section">
        <h2 className="separator-title text-center"
          data-aos="fade-up"
          style={{ color: "#d4561a" }}>
          🌍 Featured International Events
        </h2>
        <div className="separator-line mb-5"></div>
        <div className="events-grid">
          {events.map((event) => (
            <div key={event.id} className="event-card" data-aos="zoom-in">
              <div className="event-img">
                <img src={event.image} alt={event.title} />
                <span className="event-badge">{event.date}</span>
              </div>
              <div className="event-info">
                <h3>{event.title}</h3>
                <p className="event-meta">
                  <FaMapMarkerAlt /> {event.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="cta-section" data-aos="fade-up">
        <h2>Join Us at Global Events</h2>
        <p>
          Connect with global leaders and industry experts to make a difference.
        </p>
        <button className="cta-btn" onClick={handleContactRedirect}>
          Get Involved
        </button>
      </section> */}

      <Footer />
    </div>
  );
};

export default InternationalEventsParticipation;
